import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { useEffect } from 'react';
import { cln } from '../../lib/utils';

interface Props {
  value: string;
  className?: string;
}

export function RichTextPreview({ value, className }: Props) {
  const id = crypto.randomUUID();
  const editor = useEditor({
    extensions: [StarterKit],
    content: value,
    injectCSS: true,
    editable: false,
    editorProps: { attributes: { class: '!p-0' } },
  });

  useEffect(() => {
    if (editor && value) {
      editor?.commands.setContent(value);
    }
  }, [value, editor]);

  return (
    <span className={cln('richtext', className)}>
      <div className="rt-wrapper !bg-transparent border-none">
        <EditorContent className="rt-editor" id={id} editor={editor} />
      </div>
    </span>
  );
}
